import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, ChartDataLabels);

// Map job types to CSS variable indexes
const jobTypeToCSSVarIndex = {
  'Paving': 15,        // cd15
  'Dirt Hauling': 16,  // cd16
  'Gravel Supply': 17, // cd17
};

const getColorFromCSS = (jobType) => {
  const index = jobTypeToCSSVarIndex[jobType] || 1;
  return getComputedStyle(document.documentElement)
    .getPropertyValue(`--cd${index}`)
    .trim();
};

export const TruckTrendChart = ({ data = [], innerData = [] }) => {
  const ToolTipBG = getComputedStyle(document.documentElement)
    .getPropertyValue('--tooltip-bg')
    .trim() || '#222';

  // Outer dataset
  const outerLabels = data.map(d => d.job_type || '');
  const outerCounts = data.map(d => d.count || 0);
  const outerColors = outerLabels.map(getColorFromCSS);

  // Inner dataset
  const innerLabels = innerData.map(d => d.job_type || '');
  const innerCounts = innerData.map(d => d.count || 0);
  const innerColors = innerLabels.map(getColorFromCSS);

  const chartData = {
    labels: outerLabels,
    datasets: [
      {
        data: outerCounts,
        backgroundColor: outerColors,
        borderWidth: 2,
        borderColor: '#fff',
        hoverOffset: 10,
      },
      ...(innerData.length > 0
        ? [{
            data: innerCounts,
            backgroundColor: innerColors,
            borderWidth: 2,
            borderColor: '#fff',
            hoverOffset: 10,
            label: 'Inner Jobs',
          }]
        : []
      ),
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: ToolTipBG,
        titleFont: { size: 14 },
        bodyFont: { size: 13 },
        callbacks: {
          label: (context) => {
            const label = context.chart.data.labels[context.dataIndex] || '';
            const value = context.parsed;
            return `${label}: ${value} Job${value !== 1 ? 's' : ''}`;
          },
        },
      },
      datalabels: { display: false },
    },
    animation: { animateScale: true, animateRotate: true },
    hover: { mode: null },
  };

  return (
    <div className="chart-container piechart-wraper">
      <Pie data={chartData} options={options} />
    </div>
  );
};
